<!--
 * @Autor: 李建鹏
 * @Date: 2021-12-14 13:54:27
 * @LastEditTime: 2022-09-29 14:49:54
 * @Description: 增加瑕疵图
-->
<style lang="scss" scoped>
  @import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
  .new-b2c-value-item {
    margin-bottom: 18px;
    .con {
      display: flex;
      align-items: center;
      .con_name {
        .name_question {
          width: 20px;
          height: 20px;
          margin-left: 8px;
          margin-top: -1px;
          vertical-align: middle;
        }
      }
      .qc-tip img {
        margin-left: 8px;
        width: 22px;
        height: 22px;
      }
    }
    .group-outer {
      margin-top: 28px;
      background: #fafafa;
      border-radius: 4px;
      font-size: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 300;
      color: #666666;
      line-height: 30px;
      padding: 12px 16px;
    }
    .tab-desc {
      // width: 598px;
      // height: 118px;
      background: #fafafa;
      border-radius: 4px;
      font-size: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 300;
      color: #666666;
      line-height: 30px;

      .explain-text {
        font-size: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 300;
        color: #666666;
        line-height: 30px;
        position: relative;
        display: inline-block;
        &::after {
          @include hairline(#666);
          border-bottom-width: 0.5px;
          top: calc(-50% - 6px);
        }
      }
    }
    .line {
      position: relative;
      flex: 1;
      display: inline-block;
      height: 1px;
      margin: 0 16px;
      position: relative;
      &::after {
        @include hairline(#d8d8d8);
        border-bottom-width: 1px;
        border-bottom-style: dashed;
      }
    }
    .abnormal {
      color: #ffae3c;
    }
    .icon-arrow {
      width: 8px;
      height: 14px;
      margin-left: 8px;
      margin-top: -1px;
      vertical-align: middle;
    }
    .desc-info {
      margin-top: 16px;
      padding-left: 20px;
      line-height: 28px;
      position: relative;
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 9px;
        height: 7px;
      }
    }
    .desc-info::before {
      content: '';
      position: absolute;
      top: 0;
      left: 3.5px;
      width: 1px;
      height: 100%;
      border-left: 1px dashed #d8d8d8;
    }
    .value_item_img {
      height: 36px;
      width: 36px;
      margin-left: 16px;
      position: relative;
      z-index: 10;
      &.value_item_img_active {
        position: relative;
        left: -3px;
        top: -4px;
        &::after {
          content: '';
          position: absolute;
          z-index: -1;
          height: 36px;
          width: 36px;
          top: 0;
          left: 0;
          margin-top: 6px;
          margin-left: 6px;
          border-radius: 4px;
          background: #d9d9d9;
          box-sizing: border-box;
          border: 0.5px solid #999999;
        }
        img {
          border-radius: 4px;
          border: 0.5px solid #fff;
          height: 36px;
          width: 36px;
          border-radius: 6px;
        }
      }
      img {
        height: 100%;
        width: 100%;
        border-radius: 4px;
      }
      &::before {
        content: '';
        position: absolute;
        top: -10px;
        left: -10px;
        bottom: -10px;
        right: -10px;
      }
      .value_examples {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: 18px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #111;
        line-height: 27px;
        white-space: nowrap;
        // margin-top: -1px;
        &::after {
          @include hairline(#111);
          border-bottom-width: 1px;
        }
      }
    }

    .value-abstyle {
      display: flex;
      align-items: center;
      .img-style {
        margin: 0 16px 0 0;
      }
    }
  }
</style>

<template>
  <div class="new-b2c-value-item">
    <div class="con">
      <div class="con_name" @click="itemClick()">
        <span class="k">{{ title }}</span>
        <img
          v-if="showQuestionIcon"
          class="name_question"
          :src="
            $setPicSize(
              'https://pic3.zhuanstatic.com/zhuanzh/280e9ecd-2f3c-444b-a7a7-5a832773342c.png'
            )
          "
        />
      </div>
      <span class="line"></span>
      <!-- reportStyle === 3 实验组 瑕疵项解读需求调整的质检报告样式 2是对照组 旧的质检报告样式 -->
      <template v-if="reportStyle === 3">
        <div class="value-abstyle" @click="jumpFaultyAnalysisPage()">
          <div
            v-if="qcData.flawedImgVo && qcData.flawedImgVo.length > 0 && qcData.template != 1"
            v-zpm="{
              sectionid: 158,
              sortname: '瑕疵图',
            }"
            class="value_item_img img-style"
            :class="{ value_item_img_active: qcData.flawedImgVo && qcData.flawedImgVo.length > 1 }"
          >
            <img :src="$setPicSize(qcData.flawedImgVo[0].imgUrl, 48, 48)" />
          </div>
          <span :class="['v', { abnormal: qcData.isNormal !== 1 }]">{{ qcData.value }}</span>
          <!-- 订单详情页质检报告的icon会缩小 换成图片 -->
          <!-- <z-icon
            v-if="qcData.isNormal !== 1"
            class-prefix="zziconfont"
            name="arrow-right"
            color="#FFAE3C"
            size="30px"
          /> -->
          <img
            v-if="qcData.isNormal !== 1"
            class="icon-arrow"
            :src="
              $setPicSize('//pic2.zhuanstatic.com/zhuanzh/690c81ac-0aef-45cf-adcc-898f31959376.png')
            "
          />
        </div>
      </template>
      <template v-if="reportStyle != 3">
        <div class="value-abstyle">
          <span :class="['v', { abnormal: qcData.isNormal !== 1 }]">{{ qcData.value }}</span>
          <div
            v-if="qcData.flawedImgVo && qcData.flawedImgVo.length > 0"
            v-zpm="{
              sectionid: 158,
              sortname: qcData.template && qcData.template == 1 ? '示例图' : '瑕疵图',
            }"
            class="value_item_img 666"
            :class="{ value_item_img_active: qcData.flawedImgVo && qcData.flawedImgVo.length > 1 }"
            @click="checkBigImage(qcData.flawedImgVo[0].origImgUrl)"
          >
            <div v-if="qcData.template && qcData.template == 1" class="value_examples">示例</div>
            <img v-else :src="$setPicSize(qcData.flawedImgVo[0].imgUrl, 48, 48)" />
          </div>
        </div>
      </template>
    </div>
    <div v-if="qcData.subGroupExplain" class="group-outer">
      <div v-if="qcData.subGroupExplain" class="tab-desc" @click="openInfoDialog">
        {{ qcData.subGroupExplain }}
        <span
          v-if="
            qcData.subGroupExplainPopUp &&
            qcData.subGroupExplainPopUp.buttonText &&
            qcData.subGroupExplainPopUp.groupExplainPopUp
          "
          class="explain-text"
          >{{ qcData.subGroupExplainPopUp.buttonText }}</span
        >
      </div>
    </div>

    <info-dialog
      v-if="
        qcData.subGroupExplainPopUp &&
        qcData.subGroupExplainPopUp.buttonText &&
        qcData.subGroupExplainPopUp.groupExplainPopUp
      "
      ref="deliveryDialogRef"
      :title="qcData.subGroupExplainPopUp.groupExplainPopUp.title"
      :infoData="qcData.subGroupExplainPopUp.groupExplainPopUp.repairPopUpInfo"
    />

    <div v-if="qcData.desc" class="desc-info">
      <img src="https://pic5.zhuanstatic.com/zhuanzh/31c17c30-de4c-4eed-b2c8-acd43617a03a.png" />
      {{ qcData.desc }}
    </div>
  </div>
</template>
<script>
  import { previewImgClick } from '../../utils/useBigImages'
  import { hasSupportFeature, isPlatform, browserLuxuryImages, skipToUrl } from '../../utils/native'
  import { getCheckBigImageList } from '../../utils/checkBigImages'
  import { getQuery } from '../../utils'
  import { setPicSize } from '@zz-common/zz-utils'
  import infoDialog from './info-dialog'

  export default {
    components: {
      infoDialog,
    },
    props: {
      title: {
        type: [String],
        required: true,
      },
      planIds: {
        type: String,
        default: '',
      },
      qcData: {
        type: [Object],
        required: true,
      },
      item: {
        type: [Object, Array],
        default: () => {
          return {}
        },
      },
      qcIndex: {
        type: [Number],
        default: 0,
      },
      // 质检编码
      qcCode: {
        type: String,
        default: '',
      },
      // 页面id 埋点需要
      pageId: {
        type: String,
        default: '',
      },
      // 类目id 埋点需要
      cateId: {
        type: Number,
        default: 0,
      },
      indicatorGroup: {
        type: Array,
        default: () => [],
      },
      // 质检报告样式 2：新版质检报告 3： 带有瑕疵项解读的质检报告
      reportStyle: {
        type: [String, Number],
        default: 2,
      },
      // 跳转瑕疵项解读页需要的infoId
      infoId: {
        type: String,
        default: () => getQuery('infoId'),
      },
    },
    data() {
      return {
        flawedImgList: [],
      }
    },
    computed: {
      $setPicSize() {
        return setPicSize
      },
      getflawedImgVoList() {
        return []
      },
      // 是否展示百科图标 瑕疵项解读reportStyle === 3 不展示
      showQuestionIcon() {
        return (
          this.reportStyle != 3 &&
          (this.qcData.smallEncyclopediaPic ||
            (this.qcData.standardDefines && this.qcData.standardDefines.length))
        )
      },
    },
    methods: {
      /**
       * $ 查看质检百科弹窗
       */
      itemClick() {
        if (this.showQuestionIcon) {
          this.$emit('itemClick')
        }
      },
      /**
       * $ 跳转瑕疵项解读页
       */
      jumpFaultyAnalysisPage() {
        console.log(this.item, this.infoId, '跳转瑕疵项解读页', this.qcData)
        const { firstItemId, itemId: secondItemId, valueId: thirdItemId, groupId } = this.qcData
        const saleCombineIds = getQuery('saleCombineIds') || getQuery('packageId')
        const cateId = this.cateId
        if (!this.infoId || this.qcData.isNormal == 1) return
        const targetUrl = `https://m.zhuanzhuan.com/u/b2c_one_page_bizs/faultyAnalysis.html?platformType=zz&bgARGB=FF000000&needHideHead=3${
          saleCombineIds ? '&saleCombineIds=1' : ''
        }&infoId=${
          this.infoId
        }&pgCateId=${cateId}&groupId=${groupId}&firstItemId=${firstItemId}&secondItemId=${secondItemId}&thirdItemId=${thirdItemId}&planId=${
          this.planIds
        }`
        window.parent.postMessage(`checkMoreReport=${targetUrl}`, '*')
        skipToUrl({
          targetUrl,
        })
      },

      checkBigImage(select) {
        // 单瑕疵图多拍之前的逻辑
        // const { data: imgList = [], collectObj = {}, imgDataList = [] } = dataList
        //获取细节图对应的瑕疵项

        const flawedImgVo = this.indicatorGroup.find((item) => item.title == '细节图')
        const { data: imgList = [], itemIds = [], imgDataList = [] } = flawedImgVo

        this.flawedImgList = [
          {
            title: '细节图',
            subtitle: '细节',
            total: imgList.length,
            data: imgList,
            imgDataList: imgDataList,
            itemIds: itemIds,
          },
        ]

        const tabList = getCheckBigImageList({
          indicatorGroup: this.flawedImgList,
          qcCode: this.qcCode,
        })
        const idx = imgList.indexOf(select) || 0
        if (isPlatform('zz')) {
          hasSupportFeature({ method: 'browserLuxuryImages' }, (res) => {
            if (res && res.code && res.code != '-1') {
              browserLuxuryImages({ selectedIndex: idx, tabList, zpmPageId: this.pageId })
            } else {
              previewImgClick(imgList, [], idx)
            }
          })
        } else {
          window.parent.postMessage(`imageUrl=${imgList[idx]}`, '*')
          previewImgClick(imgList, [], idx)
        }
      },

      // 处理详情字段
      formatDesc(zItem, newValue) {
        const value = newValue || zItem.value
        const sItem =
          zItem.standardDefines &&
          zItem.standardDefines.length &&
          zItem.standardDefines.find((sItem) => sItem.qcItemName === value) // 获取当前百科数据 客户端预览大图需要用到此数据
        const flawDesc = sItem && sItem.defineDesc && sItem.defineDesc[0]
        return {
          sItem,
          flawDesc,
        }
      },
      openInfoDialog() {
        this.$refs.deliveryDialogRef && this.$refs.deliveryDialogRef.open()
      },
    },
  }
</script>
